<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="result-table nopads" style="width: 100%; scrollbar-width: none; -ms-overflow-style: none;">
        <vue3-datatable
            ref="resultTable"
            :rows="tripItems"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="tripItems.length > 7 ? '47.5em' : '100%'"
            :sortable="true"
            :row-class="getRowClass"
            cell-class="routa-table-cell"
            :has-checkbox="hasCheckbox"
            @row-click="rowClicked"
            @row-select="onRowSelect"
        >
            <template #startTime="data">{{ data.value.start }}</template>
            <template #endTime="data">{{ data.value.end }}</template>
            <template #tripnote="data">
                <span v-if="data.value.tripnotes?.length > 0">
                    <span
                        v-for="note in data.value.tripnotes"
                        :key="note.id"
                        class="d-block"
                    >
                        <strong>{{ toLocalTime(note.start_time) }}–{{ toLocalTime(note.end_time) }}</strong>: {{ note.note }}
                    </span>
                </span>
            </template>

            <template #csv="data">
                <div class="nopads pt-1" @click.stop="$emit('downloadGeometry', data.value.id)">
                    <font-awesome-icon
                        icon="file-csv"
                        class="row-icon"
                        style="color: #4AAE9B"
                        title="CSV"/>
                </div>
            </template>

            <template #trip_pdf="data">
                <div class="nopads pt-1" @click.stop="$emit('downloadPdf', data.value.id)">
                    <font-awesome-icon
                        icon="file-pdf"
                        class="row-icon"
                        style="color: #4AAE9B"
                        :title="$t('trip.download_trip_with_observation_pdf')"
                    />
                </div>
            </template>

            <template #geojson="data">
                <div class="nopads pt-1" @click.stop="$emit('downloadGeoJson', data.value.id)">
                    <font-awesome-icon
                        icon="map"
                        class="row-icon"
                        style="color: #4AAE9B"
                        title="GeoJSON"
                    />
                </div>
            </template>

        </vue3-datatable>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {vehicleHelper} from '../mixins/VehicleMixin'
import Vue3Datatable from '@bhplugin/vue3-datatable'

export default {
    name: 'TripList',
    components: {Vue3Datatable},
    mixins: [timeUtils, vehicleHelper],
    props: {
        isMapViewer: {
            type: Boolean,
            default: () => false
        },
        trips: {
            type: Array,
            default: () => ([])
        }
    },
    data() {
        return {
            selectedRowId: null,
            loading: 0,
        }
    },
    computed: {
        hasCheckbox() {
            return !this.isMapViewer
        },
        fields() {
            if (!this.isMapViewer) {
                return [
                    {
                        field: 'company',
                        title: this.$t('users.company'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'driver',
                        title: this.$t('trip_list.driver'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'vehicle',
                        title: this.$t('trip_list.vehicle'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'mode',
                        title: this.$t('trip_list.mode'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'customer',
                        title: this.$t('contracts.customer'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'contract',
                        title: this.$t('orders.contract'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'order',
                        title: this.$t('vehicle_position.order'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'startTime',
                        title: this.$t('trip_list.start_time'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'startRoad',
                        title: this.$t('trip_list.start_loc'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'endTime',
                        title: this.$t('trip_list.end_time'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'endRoad',
                        title: this.$t('trip_list.end_loc'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'duration',
                        title: this.$t('trip_list.duration') + ' (H:mm)',
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'length',
                        title: this.$t('trip_list.trip_length'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'avg_speed',
                        title: this.$t('trip_list.avg_speed'),
                        sort: true,
                        type: 'number',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'delivery',
                        title: this.$t('contract_reports.unload_records.delivery_amount'),
                        sort: true,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'tripnote',
                        title: this.$t('daily_summary.trip_notes'),
                        sort: false,
                        minWidth: '20em',
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'csv',
                        title: "",
                        sort: false,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'trip_pdf',
                        title: "",
                        sort: false,
                        headerClass: 'routa-table-header'
                    },
                    {
                        field: 'geojson',
                        title: "",
                        sort: false,
                        headerClass: 'routa-table-header'
                    }
                ]
            }
            return [
                {
                    field: 'vehicle',
                    title: this.$t('trip_list.vehicle'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'mode',
                    title: this.$t('trip_list.mode'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'contract',
                    title: this.$t('orders.contract'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'order',
                    title: this.$t('vehicle_position.order'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'startTime',
                    title: this.$t('trip_list.start_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'startRoad',
                    title: this.$t('trip_list.start_loc'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'endTime',
                    title: this.$t('trip_list.end_time'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'endRoad',
                    title: this.$t('trip_list.end_loc'),
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'duration',
                    title: this.$t('trip_list.duration') + ' (H:mm)',
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'length',
                    title: this.$t('trip_list.trip_length'),
                    type: 'number',
                    sort: true,
                    headerClass: 'routa-table-header'
                },
                {
                    field: 'avg_speed',
                    title: this.$t('trip_list.avg_speed'),
                    sort: true,
                    type: 'number',
                    headerClass: 'routa-table-header'
                }
            ]
        },

        tripItems() {
            return this.trips.map((trip) => {
                const duration_min = this.getDurationInMinutes(trip.start_time, trip.end_time);
                const duration = this.getWorkTime(duration_min);
                return {
                    id: trip.id,
                    company: trip.company_name || '-',
                    driver: trip.driver,
                    vehicle: this.isMapViewer ? this.getVehicleTypeName(trip.vehicle_type) : trip.vehicle,
                    mode: this.getTripModeString(trip.mode),
                    customer: trip.customer || '-',
                    contract: trip.contract || '-',
                    order: trip.order || '-',
                    start: this.toLocalTime(trip.start_time),
                    end: this.toLocalTime(trip.end_time),
                    startTime: new Date(trip.start_time).getTime(),
                    endTime: new Date(trip.end_time).getTime(),
                    startRoad: trip.start_road,
                    endRoad: trip.end_road,
                    length: parseFloat(trip.length < 10 ?
                        trip.length.toFixed(3) :
                        trip.length.toFixed(1)
                    ),
                    duration,
                    avg_speed: this.getAverageSpeed(trip.length, duration_min),
                    delivery: trip.delivery_amount ? trip.delivery_amount + ' ' + trip.delivery_unit : '-',
                    tripnotes: trip.tripnotes
                }
            })
        }
    },
    methods: {
        getTableItems() {
            return this.tripItems
        },

        rowClicked(item) {
            this.$emit('rowClicked', item)
            this.selectedRowId = item ? item.id : null
        },

        onRowSelect(selectedRows) {
            const selectedIds = selectedRows.map(r => r.id)
            const originalTrips = this.trips.filter(trip => selectedIds.includes(trip.id))
            this.$emit('toggleSelection', originalTrips)
        },

        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        setSelection(index) {
            this.selectedRowId = null
            if (index >= 0 && index < this.trips.length) {
                this.selectedRowId = this.trips[index].id
            }
        },

        resetSelection() {
            this.selectedRowId = null
            this.$refs.resultTable?.clearSelectedRows()
        },

        scrollToRow(index) {
            this.$nextTick(() => {
                if (index >= 0 && index < this.trips.length) {
                    const targetId = this.trips[index].id
                    const rowElement = document.querySelector(`.row-id-${targetId}`)
                    if (rowElement) {
                        rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }
                }
            })
        }
    }
}
</script>
<style>
</style>
